module.exports = __webpack_public_path__ + "media/images/icons/country_flags/xx-96f901b4ca23142ad779d70300e6936e.svg";